import { AlertTriangle, Shield, Activity } from "lucide-react";
import TariffCalculator from "./TariffCalculator";
import type { CityData } from "@/utils/cityData";
interface RiskCalculatorHybridProps {
  city: CityData;
}
const RiskCalculatorHybrid = ({
  city
}: RiskCalculatorHybridProps) => {
  const topRisks = [{
    icon: AlertTriangle,
    title: "Ransomware-Angriffe",
    description: "Verschlüsselung Ihrer Patientendaten durch Cyberkriminelle",
    stats: "Ø 15.000€ Lösegeld",
    severity: "Kritisch"
  }, {
    icon: Shield,
    title: "DSGVO-Verstöße",
    description: "Datenschutzverletzungen können teuer werden",
    stats: "Bis 20 Mio. € Bußgeld",
    severity: "Hoch"
  }, {
    icon: Activity,
    title: "Praxis-Stillstand",
    description: "Betriebsausfall durch IT-Systemausfall",
    stats: "2.500€/Tag Verlust",
    severity: "Hoch"
  }];
  return <section className="py-8 sm:py-12 lg:py-16 relative">
      <div className="container mx-auto max-w-6xl px-3 sm:px-4 lg:px-8">
        <div className="text-center mb-8 sm:mb-10 lg:mb-12">
          <h2 className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-bold mb-3 sm:mb-4 bg-clip-text text-transparent bg-gradient-to-r from-primary via-accent to-primary">
            Ihre Praxis schützen – Jetzt berechnen
          </h2>
          <p className="text-sm sm:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto">
            Diese Risiken bedrohen Praxen in {city.name} täglich. Berechnen Sie Ihren individuellen Schutz.
          </p>
        </div>

        <div className="flex justify-center">
          <div className="w-full max-w-3xl backdrop-blur-xl bg-white/[0.115] border-2 border-accent/40 rounded-2xl sm:rounded-[33px] p-4 sm:p-6 lg:p-8 shadow-[2px_8px_8px_rgba(0,0,0,0.3)]">
            <TariffCalculator city={city} />
          </div>
        </div>
      </div>
    </section>;
};
export default RiskCalculatorHybrid;